import { createSlice } from '@reduxjs/toolkit';
import { $authHost } from "../../http";
import { act } from 'react';
import { check } from '../../http/userApi';



// Хелпер для глубокого сравнения массивов
const arraysEqual = (a, b) => {

    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    return a.every((item, index) =>
        // JSON.stringify(item) === JSON.stringify(b[index])
        item.fid === b[index].fid

    );
};

function preprocessing(data, size = 14) {

    let res = data
    const maxWidth = null

    if (data && data.pillars) {
        const hasPrecalculatedSizes = data.pillars[0]?.textSizes;
        if (hasPrecalculatedSizes) {
            const fntsize = window.innerWidth < 768 ? (size - 4) : (size - 2);
            const sizeKey = fntsize <= 10 ? 'size10' : 'size12';

            res.pillars = data.pillars.map(pillar => {
                if (pillar.textSizes && pillar.textSizes[sizeKey]) {
                    return {
                        ...pillar,
                        textSize: pillar.textSizes[sizeKey].textSize,
                        textSizeAccountingId: pillar.textSizes[sizeKey].textSizeAccountingId,
                        textSizeAccountingFull: pillar.textSizes[sizeKey].textSizeAccountingFull,
                        textSizes: null
                    }
                }
            })
        } else {

            let fntsize = window.innerWidth < 768 ? (size - 4) : (size - 2)
            const temp = document.createElement('span');
            if (maxWidth) {
                temp.style.display = 'block'
                temp.style.maxWidth = `${maxWidth}px`
                temp.style.width = `${maxWidth}px`
            } else {
                temp.style.whiteSpace = 'nowrap';
            }
            temp.style.font = `${fntsize}px 'Roboto-Light', sans-serif`;
            temp.style.lineHeight = '1'
            temp.style.margin = '0'
            document.body.appendChild(temp);


            res = {
                ...res,
                pillars: res.pillars.map(pillar => {
                    let textSize = null
                    let textSizeAccountingId = null
                    let textSizeAccountingFull = null
                    if (pillar.name) {
                        temp.innerHTML = pillar.name;
                        let rect = temp.getBoundingClientRect();
                        textSize = { width: rect.width, height: rect.height }

                        temp.innerHTML = `${pillar.name}${pillar.accounting ? ' id' + pillar.accounting.id + (pillar.accounting.checklist ? ' ' + pillar.accounting.checklist.join(',') : '') : ''}`;
                        rect = temp.getBoundingClientRect();
                        textSizeAccountingId = { width: rect.width, height: rect.height }

                        temp.innerHTML = `${pillar.name}${pillar.accounting ? ' id' + pillar.accounting.id + (pillar.accounting.checklist ? ' ' + pillar.accounting.checklist.join(',') : '') + ' - ' + pillar.accounting.instructions : ''}`;
                        rect = temp.getBoundingClientRect();
                        textSizeAccountingFull = { width: rect.width, height: rect.height }
                    }
                    return {
                        ...pillar,
                        textSize,
                        textSizeAccountingId,
                        textSizeAccountingFull
                    }
                })
            }
            document.body.removeChild(temp);
        }
    }
    if (data && data.transformers) {
        const hasPrecalculatedSizes = data.transformers[0]?.textSizes;

        if (hasPrecalculatedSizes) {
            const fntsize = window.innerWidth < 768 ? (size - 2) : size
            const sizeKey = fntsize <= 12 ? 'size12' : 'size14';
            res.transformers = data.transformers.map(tr => {
                return {
                    ...tr,
                    textSize: tr.textSizes[sizeKey],
                    textSizes: null
                }
            })
        } else {

            let fntsize = window.innerWidth < 768 ? (size - 2) : size
            const temp = document.createElement('span');
            if (maxWidth) {
                temp.style.display = 'block'
                temp.style.maxWidth = `${maxWidth}px`
                temp.style.width = `${maxWidth}px`
            } else {
                temp.style.whiteSpace = 'nowrap';
            }
            temp.style.font = `${fntsize}px 'Roboto-Light', sans-serif`;
            temp.style.lineHeight = '1'
            document.body.appendChild(temp);
            // context.font = `${fntsize}px 'Roboto-Light', sans-serif` || getComputedStyle(document.body).font;
            res = {
                ...res,
                transformers: res.transformers.map(tr => {
                    let textSize = null
                    temp.innerHTML = `${tr.tp.replace(/^ТП/, 'КТП')}${tr.nickname ? '(' + tr.nickname + ')' : ''}`
                    let rect = temp.getBoundingClientRect();
                    textSize = { width: rect.width, height: rect.height }
                    return {

                        ...tr,
                        textSize

                    }
                })
            }
            document.body.removeChild(temp);
        }
    }
    return res
}

const measureText = (text, size, maxWidth = null) => {
    const temp = document.createElement('span');
    // temp.style.visibility = 'hidden';

    temp.style.font = `${size}px 'Roboto-Light', sans-serif`;
    if (maxWidth) {
        temp.style.display = 'block'
        temp.style.maxWidth = `${maxWidth}px`
        temp.style.width = `${maxWidth}px`
    } else {
        temp.style.whiteSpace = 'nowrap';
    }
    temp.style.lineHeight = '1'
    document.body.appendChild(temp);
    temp.innerHTML = text;
    const rect = temp.getBoundingClientRect();
    document.body.removeChild(temp);
    return { width: rect.width, height: rect.height }
};

export const fetchState = () => async (dispatch, getState) => {
    const currentUser = getState().state.user
    console.log(currentUser)
    if (currentUser.id === 0) return
    try {
        $authHost.get(currentUser.roles.some(r => ['admin', 'project_manager', 'editor', 'viewer', 'authors_control'].includes(r)) ? '/apig/state' : `/apig/state/electricity/${currentUser.id}`).then(res => {
            // $authHost.get(`/apig/state/electricity/20`).then(res => {

            const { data } = res
            const currentState = getState().state
            // console.log(currentState.hash, data.hash)
            if (!currentState.electricity) {
                dispatch(setElectricity(data));
            } else {
                if (currentState.electricityHash !== data.hash) dispatch(setElectricity(data));
            }


        }).catch(err => {
            // throw new Error(err)
            dispatch(setError(err.message));
        })

    } catch (err) {
        dispatch(setError(err.message));
    }
};

export const fetchProjects = () => async (dispatch, getState) => {
    try {
        $authHost.get('/apig/state/electricity/projects').then(res => {
            // $authHost.get(`/apig/state/electricity/7`).then(res => {
            const { data } = res
            dispatch(setProjects(data));
        }).catch(err => {
            // throw new Error(err)
            dispatch(setError(err.message));
        })
    } catch (err) {
        dispatch(setError(err.message));
    }
};

export const fetchAccounting = () => async (dispatch, getState) => {
    try {
        $authHost.get('/apig/state/accounting').then(res => {

            const { data } = res
            // console.log(data)
            const currentState = getState().state
            if (!currentState) {
                dispatch(setAccounting(data));
            } else {
                if (currentState.accountingHash !== data.hash) dispatch(setAccounting(data));
            }
        }).catch(err => {
            // throw new Error(err)
            dispatch(setError(err.message));
        })

    } catch (err) {
        dispatch(setError(err.message));
    }
};

export const fetchStateGrid = (params) => async (dispatch) => {
    try {
        $authHost.post('/apig/state/grid', params).then(res => {
            const { data } = res
            dispatch(setElectricity(data));
        }).catch(err => {
            // throw new Error(err)
            dispatch(setError(err.message));
        })

    } catch (err) {
        dispatch(setError(err.message));
    }
};

export const fetchSpecs = () => async (dispatch) => {
    try {
        $authHost.get('/apig/state/specs').then(res => {
            const { data } = res
            dispatch(setSpecs(data));
        }).catch(err => {
            dispatch(setError(err.message));
        })
    } catch (err) {
        dispatch(setError(err.message));
    }
}

export const fetchSpecsNew = () => async (dispatch) => {
    try {
        $authHost.get('/apig/state/specs_new').then(res => {
            const { data } = res
            dispatch(setSpecsNew(data));
        }).catch(err => {
            dispatch(setError(err.message));
        })
    } catch (err) {
        dispatch(setError(err.message));
    }
}

export const fetchUsersSettings = () => async (dispatch) => {
    try {
        $authHost.get('/apig/users/settings').then(res => {
            const { data } = res.data
            dispatch(setUsersSettings(data));
        }).catch(err => {
            dispatch(setError(err.message));
        })
    } catch (err) {
        dispatch(setError(err.message));
    }
}

export const fetchConclusions = () => async (dispatch) => {
    try {
        $authHost.get('/apig/state/conclusions').then(res => {
            const { data } = res
            dispatch(setConclusions(data));
        }).catch(err => {
            dispatch(setError(err.message));
        })
    } catch (err) {
        dispatch(setError(err.message));
    }
}

export const fetchRules = () => async (dispatch) => {
    try {
        $authHost.get('/apig/state/rules').then(res => {
            const { data } = res
            dispatch(setRules(data));
        }).catch(err => {
            dispatch(setError(err.message));
        })
    } catch (err) {
        dispatch(setError(err.message));
    }
}

export const fetchBindingErrors = () => async (dispatch) => {

    try {
        $authHost.get('/apig/share/accounting_errors').then(res => {

            const { data } = res
            dispatch(setBindingErrors(data));
        }).catch(err => {
            dispatch(setError(err.message));
        })
    } catch (err) {
        dispatch(setError(err.message));
    }
}

export const fetchMounted = () => async (dispatch) => {
    try {
        $authHost.get('/apig/execution/latest').then(res => {
            const { data } = res
            if (data.data) {
                dispatch(setMounted(data.data));
            }

        }).catch(err => {
            dispatch(setError(err.message));
        })
    } catch (err) {
        dispatch(setError(err.message));
    }
}

export const fetchUser = (token, username) => async (dispatch) => {
    try {
        $authHost.get(`/apig/users/username/${username}`).then(res => {
            const { data } = res
            dispatch(setUser(data.data));
        }).catch(err => {
            dispatch(setError(err.message));
        })
    } catch (err) {
        dispatch(setError(err.message));
    }
}


function electricityFilter(data, filter) {
    const dateFilter = filter.find(f => f.type === 'date')?.filter
    const tpFilter = filter.find(f => f.type === 'tp')?.filter
    const dialFilter = filter.find(f => f.type === 'dial')?.filter
    const statementsFilter = filter.find(f => f.type === 'statements')?.filter
    const checklistFilter = filter.find(f => f.type === 'checklist')?.filter
    let el = data
    if (!el || el.length === 0) return []

    if (dateFilter) {
        el = {
            ...el,
            pillars: el.pillars.filter(h => new Date(h.date) >= new Date(dateFilter.start) && new Date(h.date) <= new Date(dateFilter.end)),
            pillarsOpn: el.pillarsOpn.filter(h => new Date(h.date_history) >= new Date(dateFilter.start) && new Date(h.date_history) <= new Date(dateFilter.end)),
            pillarsZvz: el.pillarsZvz.filter(h => new Date(h.date_history) >= new Date(dateFilter.start) && new Date(h.date_history) <= new Date(dateFilter.end)),
            fiders: el.fiders.filter(h => new Date(h.date_history) >= new Date(dateFilter.start) && new Date(h.date_history) <= new Date(dateFilter.end)),
            pillarsRlnd: el.pillarsRlnd.filter(h => new Date(h.date_history) >= new Date(dateFilter.start) && new Date(h.date_history) <= new Date(dateFilter.end)),
            pillarsRunn: el.pillarsRunn.filter(h => new Date(h.date_history) >= new Date(dateFilter.start) && new Date(h.date_history) <= new Date(dateFilter.end)),
        }
    }
    if (tpFilter) {
        el = {
            ...el,
            transformers: el.transformers.filter(host => !tpFilter.find(f => f === host.fid)),
            pillars: el.pillars.filter(host => !tpFilter.find(f => f === parseInt(host.tp_id))),
            pillarsOpn: el.pillarsOpn.filter(host => !tpFilter.find(f => f === parseInt(host.tp_id))),
            pillarsZvz: el.pillarsZvz.filter(host => !tpFilter.find(f => f === parseInt(host.tp_id))),
            pillarsRlnd: el.pillarsRlnd.filter(host => !tpFilter.find(f => f === parseInt(host.tp_id))),
            pillarsRunn: el.pillarsRunn.filter(host => !tpFilter.find(f => f === parseInt(host.tp_id))),
            fiders: el.fiders.filter(host => !tpFilter.find(f => f === parseInt(host.tp_id)))
        }
    }
    if (dialFilter) {
        el = {
            ...el,
            pillars: el.pillars.map(pillar => {
                let type = pillar.type ? pillar.type : 'pillar04'
                let status = pillar.status || 'default'
                let type_new = pillar.tags.type
                let opacity = 2

                //Если маркер не входит в выбранный сегмент отмечаем его как стандартный и скрываем надписи
                if (!dialFilter.labels[dialFilter.selectedLabel].includes(status)) {
                    // opacity = 0
                    // type = 'pillar04'
                    return {
                        ...pillar,
                        opacity: 0,
                        // type: 'pillar04',
                        status: 'default',
                        accounting: null
                    }
                }

                //Иначе ищем минимальный статус к сегментах куда вхож данный тип маркера, кроме сегмента Все
                dialFilter.labels.map((l, i) => {
                    if (i !== 0 && l.includes(status) && dialFilter.labelsOpacity[i] < opacity) opacity = dialFilter.labelsOpacity[i]
                })
                //Если самый низкий приоритет 0, то скрываем предписания
                if (opacity === 0) {
                    return {
                        ...pillar,
                        opacity: dialFilter.labelsOpacity[dialFilter.selectedLabel],
                        tags: { ...pillar.tags, type: '' },
                        // type: 'pillar04',
                        status: 'default',
                        accounting: null
                    }

                }
                if (dialFilter.selectedLabel === 0 && dialFilter.labelsOpacity[0] === 0) {
                    opacity = 0
                }
                // if (dialFilter.labelsOpacity[0] < opacity) {
                //     opacity = dialFilter.labelsOpacity[0]
                // }

                return {
                    ...pillar,
                    opacity,
                    status

                }
            }).filter(f => f)
        }
    }
    if (statementsFilter || checklistFilter) {
        el = {
            ...el,
            pillars: el.pillars.map(pillar => {
                if ((statementsFilter && !statementsFilter.includes(pillar.fid)) || (checklistFilter && !(pillar.accounting && pillar.accounting.checklist && pillar.accounting.checklist.find(c => checklistFilter.includes(c))))) {
                    return {
                        ...pillar,
                        opacity: 0,
                        // type: 'pillar04',
                        status: 'default',
                        accounting: null
                    }
                }
                return pillar
            })
        }

    }
    const actualStatuses = ['accounting_not_completed', 'accounting_half_completed']
    const accounting_tp_ids = [...new Set(data.pillars.filter(p => actualStatuses.includes(p.status)).map(p => p.tp_id))]
    el = {
        ...el,
        transformers: el.transformers.map(tr => {
            return {
                ...tr,
                accounting: accounting_tp_ids.find(ati => ati === tr.fid.toString()) ? true : false,
                status: accounting_tp_ids.find(ati => ati === tr.fid.toString()) ? 'accounting' : 'default',
                tags: { ...tr.tags, class: 'transformer', type: accounting_tp_ids.find(ati => ati === tr.fid.toString()) ? 'accounting' : '' }
            }
        })
    }
    return el
}

const statusMap = {
    'Не устранено': 'accounting_not_completed',
    'Частично устранено': 'accounting_half_completed',
    'Устранено частично': 'accounting_half_completed',
    'Отклонено': 'accounting_rejected',
    'Готово к проверке': 'accounting_ready',
    'Устранено': 'accounting_completed'

}

function electricityFilterNew(data, filter) {
    const start = new Date()

    const stageFilter = filter.stage

    let tpFilterSet = filter.tp ? new Set(filter.tp) : null;
    const projectsFilterSet = filter.projects ? new Set(filter.projects) : null
    const startDate = filter.date ? new Date(filter.date.start).getTime() : null;
    const endDate = filter.date ? new Date(filter.date.end).getTime() : null;


    let transformers = data.transformers || []
    if (projectsFilterSet) {
        const tpProjectsFiltered = new Set(transformers.filter(host => (host.projects && !host.projects.some(project => projectsFilterSet.has(project))) || (!host.projects && !projectsFilterSet.has(0))).map(t => t.fid));
        tpFilterSet = new Set([...(tpFilterSet || []), ...tpProjectsFiltered])
    }


    const baseFilter = (item) => {
        if (stageFilter && !stageFilter.includes(Number(item.stage))) return false;

        const date_prop = item.date_history;
        if (startDate && endDate && date_prop) {
            const itemDate = new Date(date_prop).getTime();
            if (itemDate < startDate || itemDate > endDate) return false;
        }

        if (tpFilterSet && item.tp_id && tpFilterSet.has(parseInt(item.tp_id, 10))) return false;


        return true;
    };

    let pillarsOpn = (data.pillarsOpn || []).filter(p => baseFilter(p));
    let pillarsZvz = (data.pillarsZvz || []).filter(p => baseFilter(p));
    let pillarsRlnd = (data.pillarsRlnd || []).filter(p => baseFilter(p));
    let pillarsRunn = (data.pillarsRunn || []).filter(p => baseFilter(p));
    let pillars = (data.pillars || []).filter(p => baseFilter(p));
    let fiders = (data.fiders || []).filter(p => baseFilter(p));


    // if (mountedData) {
    //     if (mountedData.pillars) pillars = pillars.map(pillar => ({ ...pillar, mount_status: mountedData?.pillars?.[pillar.fid] || pillar.mount_status }))
    //     if (mountedData.zvz) pillarsZvz = pillarsZvz.map(pillar => ({ ...pillar, mount_status: mountedData?.zvz?.[pillar.fid] || pillar.mount_status }))
    //     if (mountedData.opn) pillarsOpn = pillarsOpn.map(pillar => ({ ...pillar, mount_status: mountedData?.opn?.[pillar.fid] || pillar.mount_status }))
    //     if (mountedData.rlnd) pillarsRlnd = pillarsRlnd.map(pillar => ({ ...pillar, mount_status: mountedData?.rlnd?.[pillar.fid] || pillar.mount_status }))
    //     if (mountedData.runn) pillarsRunn = pillarsRunn.map(pillar => ({ ...pillar, mount_status: mountedData?.runn?.[pillar.fid] || pillar.mount_status }))
    //     if (mountedData.fiders) fiders = fiders.map(fider => {
    //         if (!mountedData?.fiders?.[fider.id]) return fider
    //         console.log(fider)
    //         let mountSegments = []
    //         const segments = mountedData?.fiders?.[fider.id]?.segments
    //         if (segments && fider.connected) {
    //             fider.connected.forEach((conn, index) => {
    //                 if (index === 0) return
    //                 if (!fider.connected[index - 1] || !fider.connected[index]) return
    //                 const entry = segments[`${fider.connected[index - 1].type}_${fider.connected[index - 1].id}_${fider.connected[index].type}_${fider.connected[index].id}`]
    //                 if (!entry) {
    //                     mountSegments.push(fider.mountSegments[index - 1] || null)
    //                 } else if (entry.status < 1) {
    //                     mountSegments.push(null)
    //                 } else {
    //                     mountSegments.push(entry.progress < 0.98 ? '255,0,0' : entry.progress > 1.02 ? '255,160,0' : '0,221,0')

    //                 }



    //             })
    //         } else {
    //             mountSegments = fider.mountSegments
    //         }
    //         return {
    //             ...fider,
    //             mount: mountedData?.fiders?.[fider.id] || undefined,
    //             mountSegments
    //         }
    //     })
    // }


    if (tpFilterSet) {
        transformers = transformers.filter(host => !tpFilterSet.has(host.fid));
    }

    const actualStatuses = ['accounting_not_completed', 'accounting_half_completed']
    const accounting_tp_ids = new Set((data.pillars || []).filter(p => actualStatuses.includes(p.status)).map(p => p.tp_id))

    transformers = transformers.map(tr => {
        const hasAccounting = accounting_tp_ids.has(tr.fid.toString());
        // let mount_status = tr.mount_status
        // if (mountedData?.transformers) {
        //     mount_status = mountedData.transformers?.[tr.fid]?.status || tr.mount_status
        // }
        return {
            ...tr,
            // mount_status: mount_status,
            accounting: hasAccounting,
            status: hasAccounting ? 'accounting' : 'default',
        }
    })

    const end = new Date()
    console.log('electricitiy filtering time:', (end.getTime() - start.getTime()) / 1000)

    const el = {
        ...data,
        pillarsOpn,
        pillarsZvz,
        pillarsRlnd,
        pillarsRunn,
        pillars,
        fiders,
        transformers,
    }

    return el
}

function accountingTownFilter(data, filter) {
    let ac = data
    if (!ac || ac.length === 0) return []
    const dateFilter = filter.find(f => f.type === 'date')?.filter
    const tpFilter = filter.find(f => f.type === 'tp')?.filter
    const dialFilter = filter.find(f => f.type === 'dial')?.filter
    const checklistFilter = filter.find(f => f.type === 'checklist')?.filter
    // const statementsFilter = filter.find(f => f.type === 'statements')?.filter
    ac = ac.map(acc => {
        let tps = acc.tps
        if (tpFilter) {
            tps = tps.filter(tp => !tpFilter.find(f => f.toString() === tp.tp.fid.toString()))
        }
        if (!tps) return null
        tps = tps.map(tp => {
            let pillars = tp.pillars
            if (dateFilter) {
                pillars = pillars.filter(h => new Date(h.date) >= new Date(dateFilter.start) && new Date(h.date) <= new Date(dateFilter.end))
            }
            if (dialFilter) {
                pillars = pillars.map(pillar => {
                    let status = pillar.status
                    let opacity = 2
                    dialFilter.labels.map((l, i) => {
                        if (i !== 0 && l.includes(status) && dialFilter.labelsOpacity[i] < opacity) opacity = dialFilter.labelsOpacity[i]
                    })
                    if (opacity === 0) return null
                    if (!dialFilter.labels[dialFilter.selectedLabel].includes(status)) return null
                    if (status === 'default') return null
                    return {
                        ...pillar,
                        opacity
                    }
                }).filter(f => f)

            }
            if (checklistFilter) {
                pillars = pillars.filter(pillar => pillar.accounting.checklist && pillar.accounting.checklist.find(c => checklistFilter.includes(c)))
            }
            return {
                ...tp,
                pillars: pillars,
                count: pillars.length
            }
        })
        return {
            ...acc,
            tps: tps,
            count: tps.reduce((t, r) => t + r.count, 0)
        }
    }).filter(f => f)
    return ac
}


function accountingTownFilterNew(data, filter) {
    let ac = data
    if (!ac || ac.length === 0) return []
    const dateFilter = filter.date
    const tpFilter = filter.tp
    const dialFilter = filter.dial
    const checklistFilter = filter.checklist
    const stageFilter = filter.stage
    // const statementsFilter = filter.find(f => f.type === 'statements')?.filter
    ac = ac.map(acc => {
        let tps = acc.tps
        if (tpFilter) {
            tps = tps.filter(tp => !tpFilter.find(f => f.toString() === tp.tp.fid.toString()))
        }
        if (!tps) return null
        tps = tps.map(tp => {
            let pillars = tp.pillars
            if (stageFilter && stageFilter > 0) {
                pillars = pillars.filter(h => h.stage.toString() === stageFilter.toString())
            }
            if (dateFilter) {
                pillars = pillars.filter(h => new Date(h.date_history) >= new Date(dateFilter.start) && new Date(h.date_history) <= new Date(dateFilter.end))
            }
            if (dialFilter) {
                pillars = pillars.map(pillar => {
                    let status = pillar.status
                    let opacity = 2
                    dialFilter.labels.map((l, i) => {
                        if (i !== 0 && l.includes(status) && dialFilter.labelsOpacity[i] < opacity) opacity = dialFilter.labelsOpacity[i]
                    })
                    if (opacity === 0) return null
                    if (!dialFilter.labels[dialFilter.selectedLabel].includes(status)) return null
                    if (status === 'default') return null
                    return {
                        ...pillar,
                        opacity
                    }
                }).filter(f => f)

            }
            if (checklistFilter) {
                pillars = pillars.filter(pillar => pillar.accounting.checklist && pillar.accounting.checklist.find(c => checklistFilter.includes(c)))
            }
            return {
                ...tp,
                pillars: pillars,
                count: pillars.length
            }
        })
        return {
            ...acc,
            tps: tps,
            count: tps.reduce((t, r) => t + r.count, 0)
        }
    }).filter(f => f)
    return ac
}

function accountingNewObjectFilter(data, filter) {
    let ac = data
    if (!ac || ac.length === 0) return []
    const dateFilter = filter.find(f => f.type === 'date')?.filter
    // const statementsFilter = filter.find(f => f.type === 'statements')?.filter
    if (dateFilter) {
        ac = ac.map(acc => {

            let pillars = acc.pillars.filter(h => new Date(h.date) >= new Date(dateFilter.start) && new Date(h.date) <= new Date(dateFilter.end))

            if (!pillars) return null
            return {
                ...acc,
                pillars
            }
        }).filter(f => f)
    }

    return ac
}

function accountingNewObjectFilterNew(data, filter) {
    let ac = data
    if (!ac || ac.length === 0) return []
    const dateFilter = filter.date
    const stageFilter = filter.stage
    const tpFilter = filter.tp
    // const statementsFilter = filter.find(f => f.type === 'statements')?.filter
    if (dateFilter || stageFilter || tpFilter) {
        ac = ac.map(acc => {
            if (tpFilter && tpFilter.find(f => f.toString() === acc.tp.fid.toString())) return null
            let pillars = acc.pillars
            if (stageFilter > 0) {
                pillars = pillars.filter(h => h.stage.toString() === stageFilter.toString())
            }
            if (dateFilter) {
                pillars = acc.pillars.filter(h => new Date(h.date) >= new Date(dateFilter.start) && new Date(h.date) <= new Date(dateFilter.end))
            }

            if (!pillars) return null
            return {
                ...acc,
                pillars
            }
        }).filter(f => f)
    }

    return ac
}

function accountingsFilter(data, pillars) {
    let ac = data
    if (!ac || ac.length === 0) return []

    const pillarsIds = pillars.map(p => p.fid)

    return Object.values(ac).filter(v => pillarsIds.includes(v.pillarId))
}

function accountingPreprocess(data) {
    if (!data) return null
    const acc = {}
    Object.entries(data).forEach(d => {
        let newStatus = d[1].status
        const checklist = d[1].checklist || []
        const checklistElim = d[1].part_elimin_categ || { ready: [], success: [], rejected: [] }
        if (checklist.length > 0 && (checklistElim.success?.length > 0 || checklistElim.ready?.length > 0 || checklistElim.rejected?.length > 0)) {
            if (checklistElim.success?.length === checklist.length) {
                newStatus = 'Устранено'
            } else if (checklistElim.ready?.length === checklist.length) {
                newStatus = 'Готово к проверке'
            } else if (checklistElim.rejected?.length === checklist.length) {
                newStatus = 'Отклонено'
            } else {
                newStatus = 'Частично устранено'
            }
        }
        acc[d[0]] = {
            ...d[1],
            status: newStatus
        }

    })
    return acc
}


const stateSlice = createSlice({
    name: 'state',
    initialState: {
        project: 1,
        electricity: {
            powerPlants: [],
            feedingSubstations: [],
            transformers: [],
            fider330: [],
            fider110: [],
            fider35: [],
            fiders: [],
            res: [],
            pillars: [],
            pillarsOpn: [],
            pillarsZvz: [],
            pillarsRunn: [],
            pillarsRlnd: []
        },
        electricityHash: null,
        electricityFiltered: {
            transformers: [],
            fiders: [],
            pillars: [],
            pillarsOpn: [],
            pillarsZvz: [],
            pillarsRunn: [],
            pillarsRlnd: []
        },
        projects: [],
        mounted: {
            transformers: [],
            pillars: [],
            zvz: [],
            opn: [],
            fiders: [],
            rlnd: [],
            runn: []
        },
        mountedCache:  localStorage.getItem('mountedCache') ? JSON.parse(localStorage.getItem('mountedCache')) : null,
        specs: {
            pillars: [],
            opn: [],
            zvz: [],
            fiders: [],
            rlnd: []
        },
        specs_new: {},
        user: {
            id: 0,
            display_name: '',
            roles: ['viewer']
        },
        authError: false,
        darkMode: localStorage.getItem('darkMode') === 'true' || false,
        objects_reestr: [],
        usersSettings: localStorage.getItem('usersSettings') ? JSON.parse(localStorage.getItem('usersSettings')) : [
            { id: 0, name: '', settings: { line_color: '#0000ff', text_color: '#000000', stroke_color: '#ffffff' } }
        ],
        accountings: [],
        accountingsFiltered: [],
        accountingsHash: null,
        // accountingTowns: [],
        // accountingNewObject: [],
        // accountingTownsFiltered: [],
        // accountingNewObjectFiltered: [],
        conclusions: [],
        rules: [],
        bindingErrors: [],
        filter: JSON.parse(localStorage.getItem('filter')) || {},
        status: 'idle',
        stop: false,
        error: null
    },
    reducers: {

        setElectricity(state, action) {

            if (!state.stop) {
                let data = preprocessing(action.payload.data)

                // data = {
                //     ...data,
                // pillars04Filtered: state.filter ? filterPillars04(data.pillars04, state.filter) : data.pillars04,
                // fider04Filtered: state.filter ? filterFider04(data.fider04, state.filter) : data.fider04
                // transformersFiltered: state.filter ? filterTransformers(action.payload.transformers, state.accountingFiltered, state.filter) : action.payload.transformers,
                // }
                state.electricityHash = action.payload.hash
                state.electricity = { ...state.electricity, ...data }
                state.electricityFiltered = electricityFilterNew(data, state.filter)

                state.status = 'succeeded';
            }

        },
        setAccounting(state, action) {
            if (!state.stop) {
                state.accountingsHash = action.payload.hash
                state.accountings = accountingPreprocess(action.payload.data)
                state.accountingsFiltered = accountingsFilter(state.accountings, state.electricityFiltered.pillars)
                // state.accountingTowns = action.payload.towns
                // state.accountingNewObject = action.payload.new_object
                // state.accountingTownsFiltered = accountingTownFilterNew(state.accountingTowns, state.filter)
                // state.accountingNewObjectFiltered = accountingNewObjectFilterNew(state.accountingNewObject, state.filter)
                state.status = 'succeeded';
            }

        },
        setProjects(state, action) {
            state.projects = action.payload
            if (!state.filter.projects && action.payload && action.payload.length > 0) {
                // Инициализируем фильтр проектов всеми доступными проектами
                state.filter.projects = action.payload.map(p => p.id)
                localStorage.setItem('filter', JSON.stringify(state.filter))
                // Применяем фильтр к данным электричества, если они уже загружены
                if (state.electricity && state.electricity.transformers) {
                    state.electricityFiltered = electricityFilterNew(state.electricity, state.filter)
                }
            }
        },
        setSpecs(state, action) {
            state.specs = action.payload
        },
        setSpecsNew(state, action) {
            state.specs_new = action.payload
        },
        setConclusions(state, action) {
            state.conclusions = action.payload
        },
        setRules(state, action) {
            state.rules = action.payload
        },
        setBindingErrors(state, action) {
            state.bindingErrors = action.payload
        },
        setUser(state, action) {
            state.user = action.payload
        },
        setAuthError(state, action) {
            state.authError = action.payload
        },
        setError(state, action) {
            state.error = action.payload;
            state.status = 'failed';
        },
        setUsersSettings(state, action) {
            state.usersSettings = action.payload
            state.usersSettings = [...state.usersSettings, { id: 0, name: '', settings: { line_color: '#0000ff', text_color: '#000000', stroke_color: '#ffffff' } }]
            localStorage.setItem('usersSettings', JSON.stringify(state.usersSettings))
        },
        // setDateFilter(state, action) {
        //     const filter = action.payload
        //     if (filter) {
        //         // console.log(filter)
        //         if (filter.min === filter.start && filter.max === filter.end) {
        //             state.filter = null
        //             localStorage.removeItem('dateFilter')
        //             // state.transformersFiltered = state.electricity.transformers
        //             state.electricity.pillars04Filtered = state.electricity.pillars04
        //             state.electricity.fider04Filtered = state.electricity.fider04
        //             state.accountingTownsFiltered = state.accountingTowns
        //         } else {
        //             localStorage.setItem('dateFilter', JSON.stringify(filter))
        //             state.filter = action.payload
        //             state.accountingTownsFiltered = filterAccounting(state.accountingTowns, filter)
        //             state.electricity.pillars04Filtered = filterPillars04(state.electricity.pillars04, filter)
        //             state.electricity.fider04Filtered = filterFider04(state.electricity.fider04, filter)
        //             // state.electricity.transformers.map(tr => {
        //             //     console.log(state.accountingFiltered.find(acc => acc.tps.find(tp => tp.tp.fid === tr.fid)) ? tr.accounting : null)
        //             // })
        //             // state.electricity.transformersFiltered = filterTransformers(state.electricity.transformers, state.accountingFiltered, filter)
        //             // console.log(state.electricity.transformers)

        //         }
        //     }

        // },
        setLoading(state) {
            state.status = 'loading';
        },

        setStop(state, action) {
            state.stop = action.payload
        },
        setFilter(state, action) {
            
            const [type, value] = Object.entries(action.payload)[0]
            if (state.filter[type] === value) return
            state.filter = {
                ...state.filter,
                ...action.payload
            }
            localStorage.setItem('filter', JSON.stringify(state.filter))
            state.electricityFiltered = electricityFilterNew(state.electricity, state.filter)
            if (action.payload.type !== 'statements') {
                state.accountingsFiltered = accountingsFilter(state.accountings, state.electricityFiltered.pillars)
                // state.accountingsFiltered = accountingsFilter(action.payload.data, state.electricityFiltered.pillars)
                // state.accountingTownsFiltered = accountingTownFilterNew(state.accountingTowns, state.filter)
                // state.accountingNewObjectFiltered = accountingNewObjectFilterNew(state.accountingNewObject, state.filter)
            }
        },
        // setFilter(state, action) {
        // state.filter = [
        //     ...state.filter.filter(f => f.type !== action.payload.type),
        //     action.payload
        // ]
        // localStorage.setItem('filter', JSON.stringify(state.filter))
        // state.electricityFiltered = electricityFilter(state.electricity, state.filter)
        // if (action.payload.type !== 'statements') {
        //     state.accountingTownsFiltered = accountingTownFilter(state.accountingTowns, state.filter)
        //     state.accountingNewObjectFiltered = accountingNewObjectFilter(state.accountingNewObject, state.filter)
        // }

        // },
        setMounted(state, action) {
            state.mounted = action.payload
        },
        updateMounted(state, action) {
            
            state.mountedCache = action.payload
            state.electricityFiltered = electricityFilterNew(state.electricity, state.filter, action.payload)
            localStorage.setItem('mountedCache', JSON.stringify(state.mountedCache))
            setTimeout(() => {
                localStorage.removeItem('mountedCache')
                state.mountedCache = null
            }, 5 * 60 * 1000)
            // console.log('updateMounted reducer called with payload:', action.payload);
            // console.log('Current state.mounted before update:', JSON.stringify(state.mounted, null, 2));
            // const { type, data } = action.payload
            // if (!type || !data) return

            // if (type !== 'fiders') {
            //     const existingIndex = state.mounted[type].findIndex(st => st.fid === data.fid);
            //     // console.log('Existing index:', existingIndex);
            //     if (existingIndex === -1) {
            //         // Добавляем новый элемент
            //         // console.log('Adding new item to', type);
            //         state.mounted[type].push(data);
            //     } else {
            //         // Заменяем существующий элемент
            //         // console.log('Replacing existing item at index', existingIndex, 'in', type);
            //         state.mounted[type][existingIndex] = data;
            //     }
            // } else {
            //     // console.log('Processing fider item:', data);
            //     // Для fiders в новом формате ищем только по fid
            //     const existingIndex = state.mounted[type].findIndex(st => st.fid === data.fid);
            //     // console.log('Existing fider index:', existingIndex);
            //     if (existingIndex === -1) {
            //         // Добавляем новый элемент
            //         // console.log('Adding new fider');
            //         state.mounted[type].push(data);
            //     } else {
            //         // Заменяем существующий элемент
            //         // console.log('Replacing existing fider at index', existingIndex);
            //         state.mounted[type][existingIndex] = data;
            //     }
            // }

            // console.log('state.mounted after update:', JSON.stringify(state.mounted, null, 2));

        },
        toggleDarkMode(state) {
            state.darkMode = !state.darkMode;
            localStorage.setItem('darkMode', state.darkMode.toString());
        }


    }

});


export const {
    setElectricity,
    setAccounting,
    setProjects,
    setSpecs,
    setSpecsNew,
    setError,
    setLoading,
    setFilter,
    setStop,
    setMounted,
    updateMounted,
    setConclusions,
    setRules,
    setBindingErrors,
    setUser,
    setAuthError,
    setUsersSettings,
    toggleDarkMode
} = stateSlice.actions;
export default stateSlice.reducer;